export class FullscreenManager {
    constructor(elementId = 'fullscreenButton') {
        this.element = document.getElementById(elementId);
        if (!this.element) {
            // Créer le bouton s'il n'existe pas
            this.createElement();
        }
        
        this.isFullscreen = false;
        this.init();
    }

    createElement() {
        // Créer le bouton
        this.element = document.createElement('button');
        this.element.id = 'fullscreenButton';
        this.element.title = 'Fullscreen';
        this.element.innerHTML = `
            <span class="expand-icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 3 21 3 21 9"></polyline><polyline points="9 21 3 21 3 15"></polyline><line x1="21" y1="3" x2="14" y2="10"></line><line x1="3" y1="21" x2="10" y2="14"></line></svg></span>
            <span class="compress-icon"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 14 10 14 10 20"></polyline><polyline points="20 10 14 10 14 4"></polyline><line x1="14" y1="10" x2="21" y2="3"></line><line x1="3" y1="21" x2="10" y2="14"></line></svg></span>
        `;
        
        // Ajouter le bouton au DOM
        document.body.appendChild(this.element);
    }

    init() {
        // Masquer le bouton sur iOS (Fullscreen API non supportée)
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        if (isIOS) {
            this.element.style.display = 'none';
            return;
        }

        // Écouter les clics sur le bouton
        this.element.addEventListener('click', () => this.toggle());
        
        // Écouter les changements d'état du plein écran (touche F11, Échap, etc.)
        document.addEventListener('fullscreenchange', () => this.onFullscreenChange());
        
        // Raccourci clavier F11 (optionnel)
        document.addEventListener('keydown', (event) => {
            if (event.key === 'F11') {
                event.preventDefault();
                this.toggle();
            }
        });

        //consolelog('🖥️ FullscreenManager initialisé');
    }

    toggle() {
        if (!document.fullscreenElement) {
            this.enterFullscreen();
        } else {
            this.exitFullscreen();
        }
    }

    async enterFullscreen() {
        try {
            await document.documentElement.requestFullscreen();
            this.isFullscreen = true;
            document.body.classList.add('fullscreen');
            //consolelog('🖥️ Mode plein écran activé');
        } catch (err) {
            //consoleerror('Erreur lors de l\'activation du plein écran:', err);
        }
    }

    async exitFullscreen() {
        try {
            await document.exitFullscreen();
            this.isFullscreen = false;
            document.body.classList.remove('fullscreen');
            //consolelog('🖥️ Mode plein écran désactivé');
        } catch (err) {
            //consoleerror('Erreur lors de la sortie du plein écran:', err);
        }
    }

    onFullscreenChange() {
        if (document.fullscreenElement) {
            this.isFullscreen = true;
            document.body.classList.add('fullscreen');
        } else {
            this.isFullscreen = false;
            document.body.classList.remove('fullscreen');
        }
    }

    show() {
        this.element.style.display = 'flex';
    }

    hide() {
        this.element.style.display = 'none';
    }

    // Méthode pour changer la position du bouton si nécessaire
    setPosition(top = '20px', right = '20px') {
        this.element.style.top = top;
        this.element.style.right = right;
    }

    // Méthode pour obtenir l'état actuel
    getState() {
        return {
            isFullscreen: this.isFullscreen,
            isVisible: this.element.style.display !== 'none'
        };
    }
}
